export default {
  data: () => ({
    translations: {
      title: {
        el: 'Συναλλαγές',
        en: 'Transaction',
        it: 'Transazione',
      },
      userIdentity: {
        el: 'Χρήστης',
        en: 'User Identity',
        it: "Identità dell'utente",
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Data',
      },
      totalPrice: {
        el: 'Συνολική Τιμή',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      total_points: {
        el: 'Σύνολο Πόντων',
        en: 'Total Points',
        it: 'Punti totali',
      },
      total_cashback: {
        el: 'Σύνολο Cashback',
        en: 'Total Cashback',
        it: 'Cashback totale',
      },
      receiptNumber: {
        el: 'Αριθμός Απόδειξης',
        en: 'Receipt Number',
        it: 'Numero di ricevuta',
      },
      receiptIdentifier: {
        el: 'Αναγνωριστικό Απόδειξης',
        en: 'Receipt Identifier',
        it: 'Identificatore della ricevuta',
      },
      type: {
        el: 'Τύπος',
        en: 'Type',
        it: 'Tipo',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      transactionItems: {
        el: 'Στοιχεία Συναλλαγής',
        en: 'Transaction Items',
        it: 'Elementi di transazione',
      },
      productName: {
        el: 'Όνομα Προϊόντος',
        en: 'Product Name',
        it: 'Nome del prodotto',
      },
      quantity: {
        el: 'Ποσότητα',
        en: 'Quantity',
        it: 'Quantità',
      },
      paymentMethodName: {
        el: 'Τρόπος Πληρωμής',
        en: 'Payment Method',
        it: 'Metodo di pagamento',
      },
    },
  }),
};
